import { DEFAULT_ATTRIBUTES, UID } from 'shared/api/query/constants';
import { invitation as invitationConfig, user as userConfig } from 'shared/api/query/configs.json';

export const invitationEdges = [
  ...DEFAULT_ATTRIBUTES,
  { attr: invitationConfig.edges.acceptedAt },
  { attr: invitationConfig.edges.actor, model: userConfig.model, children: [{ attr: UID }] },
  { attr: invitationConfig.edges.recipient, model: userConfig.model, children: [{ attr: UID }] },
];
